import { useMemo, useCallback } from 'react';
import { Select } from 'foundations-components/transitional/components/Select';
import { useGetAssignedPlaylistsForPortalQuery } from '../../../../../__generated__/chirp/com/hubspot/learning/center/credentials/rpc/PlaylistVisibilityChirpService.hooks';
import FormattedMessage from 'I18n/components/FormattedMessage';
import { jsx as _jsx } from "react/jsx-runtime";
const ButtonContent = ({
  count
}) => {
  if (count === 0) {
    return /*#__PURE__*/_jsx(FormattedMessage, {
      message: "learningCenter.myTeam.filters.playlist.noneSelectedLabel"
    });
  }
  return /*#__PURE__*/_jsx(FormattedMessage, {
    message: "learningCenter.myTeam.filters.playlist.someSelectedLabel",
    options: {
      count
    }
  });
};
const PlaylistFilter = ({
  onChange,
  selectedPlaylists
}) => {
  const {
    data,
    loading
  } = useGetAssignedPlaylistsForPortalQuery();
  const options = useMemo(() => {
    return data === null || data === void 0 ? void 0 : data.results.map(playlist => ({
      text: playlist.playlistName,
      value: playlist.playlistId.toString()
    }));
  }, [data === null || data === void 0 ? void 0 : data.results]);
  const handleChange = useCallback(event => {
    const selectedValues = event.target.value.map(Number);
    onChange(selectedValues);
  }, [onChange]);
  return /*#__PURE__*/_jsx(Select, {
    ButtonContent: ButtonContent,
    anchorType: "button",
    buttonContentProps: {
      count: selectedPlaylists.length
    },
    buttonUse: "transparent",
    isLoading: loading,
    menuWidth: 350,
    minimumSearchCount: 1,
    multi: true,
    onChange: handleChange,
    options: options,
    value: selectedPlaylists.map(String)
  });
};
export default PlaylistFilter;